import React, { useEffect, useState } from "react";
import { Row, Container } from "reactstrap";
import { useTranslation } from "react-i18next";

const DashboardDetail = () => {
  const { t } = useTranslation("dashboard");

  return (
    <Container fluid>
      <Row>
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h2 className="header-title mb-0">{t("title")}</h2>
              </div>
            </div>
          </div>
        </div>
      </Row>
    </Container>
  );
};

export default DashboardDetail;
